/**
 * All Permissions for Template only configuration role
 */
export const CONFIGURATION_TEMPLATE_ONLY_PERMISSIONS: string[] = [
  'dashboardView',

  // 'terminalCreate',
  'terminalView',
  'terminalDetail',
  'terminalNotes',
  // 'terminalEdit',
  'terminalConfigure',
  // 'terminalConfigureEditable',
  // 'terminalRemove',
  'terminalAssign',
  'terminalTemplateApply',
  // 'terminalMaintenance',

  'terminalBulkTemplateApply',
  // 'terminalBulkActionRestart',
  // 'terminalBulkActionPushConfig',
  // 'terminalBulkActionPullConfig',
  // 'terminalBulkActionResetConfig',
  // 'terminalBulkActionFactoryReset',
  // 'terminalBulkActionUpgradeConfig',
  // 'terminalBulkActionSetDomain',
  // 'terminalBulkActionSetType',
  // 'terminalBulkActionMigrateConfig',

  // 'terminalActionRestart',
  // 'terminalActionPushConfig',
  // 'terminalActionPullConfig',
  // 'terminalActionForcePushConfig',
  // 'terminalActionResetConfig',
  // 'terminalActionFactoryReset',
  // 'terminalActionUpgradeConfig',
  // 'terminalActionTerminalType',
  // 'terminalActionMigrateConfig',
  // 'terminalAdvancedEdit',
  // 'terminalTransactions',

  // 'registrationCreate',
  // 'registrationView',
  // 'registrationEdit',
  // 'registrationFinalize',
  // 'registrationCancel',
  // 'registrationTRF',
  // 'registrationDeactivate',
  // 'registrationRemove',

  // 'transactionView',

  // 'eventView',
  // 'terminalEventSync',

  // 'deliveryCreate',

  // 'assetView',
  // 'administrationView',

  // 'domainView',
  // 'domainCreate',
  // 'domainEdit',
  // 'domainRemove',
  // 'domainContractTypeView',
  // 'domainContractTypeEdit',
  // 'domainTerminalTypeView',
  // 'domainTerminalTypeEdit',
  // 'domainDataView',
  // 'domainDataEdit',
  // 'domainAssetView',
  // 'domainAssetEdit',
  //
  // 'roleView',
  // 'roleCreate',
  // 'roleCreateInheritable',
  // 'roleEdit',
  // 'roleRemove',
  //
  // 'userView',
  // 'userCreate',
  // 'userEdit',
  // 'userRemove',
  // 'userPasswordRequest',
  //
  // 'templateView',
  // 'templateCreate',
  // 'templateEdit',
  // 'templateRemove',
  // 'templateConfigurationEdit',
  //
  // 'contractCreate',
  // 'contractView',
  // 'contractEdit',
  // 'contractRemove',
  // 'contractMerge',
  //
  // 'taskView',
  // 'taskCreate',
  //
  // 'terminalImport',
  // 'editNotes',
]
